// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tHb3JUvnkKXjkrvzRvkdkE
// Component: bLb7PF1DBH
import * as React from "react"
import * as p from "@plasmicapp/react-web"
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
} from "@plasmicapp/react-web"
import NavBar from "../../NavBar" // plasmic-import: mLUHVmPRevK/component
import TextInput from "../../TextInput" // plasmic-import: 3dSyVCi47PG/component
import FormButton from "../../FormButton" // plasmic-import: rMBcTkwaam/component
import Footer from "../../Footer" // plasmic-import: 32zO-A5kqAr/component
import "@plasmicapp/react-web/lib/plasmic.css"
import * as projectcss from "./plasmic_stack_input_site.module.css" // plasmic-import: tHb3JUvnkKXjkrvzRvkdkE/projectcss
import * as sty from "./PlasmicSubscribe.module.css" // plasmic-import: bLb7PF1DBH/css

export const PlasmicSubscribe__VariantProps = new Array()

export const PlasmicSubscribe__ArgProps = new Array()

function PlasmicSubscribe__RenderFunc(props) {
  const { variants, args, overrides, forNode } = props
  const $props = props.args
  return (
    <React.Fragment>
      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__vhoJl)}>
            <NavBar
              data-plasmic-name={"navBar"}
              data-plasmic-override={overrides.navBar}
              className={classNames("__wab_instance", sty.navBar)}
            />

            <div className={classNames(projectcss.all, sty.freeBox__rvfQh)}>
              <h1
                data-plasmic-name={"h1"}
                data-plasmic-override={overrides.h1}
                className={classNames(
                  projectcss.all,
                  projectcss.h1,
                  projectcss.__wab_text,
                  sty.h1
                )}
              >
                {"Hear the next idea before the world does."}
              </h1>

              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text
                )}
              >
                {
                  "We hope you sign up for the StackInput monthly Ideas and Resources newsletter to hear from the StackInput community on how they'd build out different projects."
                }
              </div>

              <div className={classNames(projectcss.all, sty.freeBox___85RYe)}>
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"form"}
                  data-plasmic-override={overrides.form}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.form)}
                >
                  <div
                    data-plasmic-name={"columns"}
                    data-plasmic-override={overrides.columns}
                    className={classNames(projectcss.all, sty.columns)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.column__l3Vd)}
                    >
                      <TextInput
                        data-plasmic-name={"firstName"}
                        data-plasmic-override={overrides.firstName}
                        className={classNames("__wab_instance", sty.firstName)}
                        placeholder={"First Name"}
                      />
                    </div>

                    <div
                      className={classNames(projectcss.all, sty.column__zwgA5)}
                    >
                      <TextInput
                        data-plasmic-name={"lastName"}
                        data-plasmic-override={overrides.lastName}
                        className={classNames("__wab_instance", sty.lastName)}
                        placeholder={"Last Name"}
                      />
                    </div>
                  </div>

                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__sjvpc)}
                  >
                    <TextInput
                      data-plasmic-name={"email"}
                      data-plasmic-override={overrides.email}
                      className={classNames("__wab_instance", sty.email)}
                      placeholder={"Email"}
                    />
                  </p.Stack>

                  <FormButton
                    data-plasmic-name={"formButton"}
                    data-plasmic-override={overrides.formButton}
                    className={classNames("__wab_instance", sty.formButton)}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />
        </p.Stack>
      </div>
    </React.Fragment>
  )
}

const PlasmicDescendants = {
  root: [
    "root",
    "navBar",
    "h1",
    "text",
    "form",
    "columns",
    "firstName",
    "lastName",
    "email",
    "formButton",
    "footer",
  ],

  navBar: ["navBar"],
  h1: ["h1"],
  text: ["text"],
  form: ["form", "columns", "firstName", "lastName", "email", "formButton"],
  columns: ["columns", "firstName", "lastName"],
  firstName: ["firstName"],
  lastName: ["lastName"],
  email: ["email"],
  formButton: ["formButton"],
  footer: ["footer"],
}

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicSubscribe__ArgProps,
      internalVariantPropNames: PlasmicSubscribe__VariantProps,
    })

    return PlasmicSubscribe__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    })
  }
  if (nodeName === "root") {
    func.displayName = "PlasmicSubscribe"
  } else {
    func.displayName = `PlasmicSubscribe.${nodeName}`
  }
  return func
}

export const PlasmicSubscribe = Object.assign(
  // Top-level PlasmicSubscribe renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navBar: makeNodeComponent("navBar"),
    h1: makeNodeComponent("h1"),
    text: makeNodeComponent("text"),
    form: makeNodeComponent("form"),
    columns: makeNodeComponent("columns"),
    firstName: makeNodeComponent("firstName"),
    lastName: makeNodeComponent("lastName"),
    email: makeNodeComponent("email"),
    formButton: makeNodeComponent("formButton"),
    footer: makeNodeComponent("footer"),
    // Metadata about props expected for PlasmicSubscribe
    internalVariantProps: PlasmicSubscribe__VariantProps,
    internalArgProps: PlasmicSubscribe__ArgProps,
  }
)

export default PlasmicSubscribe
/* prettier-ignore-end */
